export default "__VITE_ASSET__1PHEsIuA__"